import React from 'react';
export default (function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    "aria-hidden": true,
    focusable: false,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8528091,9.19091242 C39.0728897,7.76353143 41.2190814,7.59548128 42.6464624,8.8155619 C44.0738434,10.0356425 44.2418935,12.1818342 43.0218129,13.6092152 L21.1765077,39.166193 C19.8419225,40.7275337 17.4382769,40.7580694 16.0644586,39.231136 L5.27248223,27.2363703 C4.01653458,25.8404445 4.13000927,23.6906764 5.52593503,22.4347287 C6.92186079,21.1787811 9.07162894,21.2922557 10.3275766,22.6881815 L18.5240294,31.8000638 L37.8528091,9.19091242 Z",
    id: "524"
  }));
});